/* eslint-disable import/no-unresolved */
import PropTypes from "prop-types";
import React from "react";
import { useMediaQuery } from "react-responsive";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import useSwiperRef from "helpers/hooks/useSwiperRef";
import IconPrevious from "solar/icons/IconPrevious";
import IconNext from "solar/icons/IconNext";
import Container from "components/adventure/Container";
import Title from "components/adventure/Title";
import Text from "components/adventure/Text";
import Highlight from "components/adventure/Highlight";
import styles from "components/adventure/Highlights.module.scss";

export default function Highlights({ title, description, highlights }) {
  const breakpointLg = parseInt(styles.solBreakpointLg, 10);
  const breakpoint2Xl = parseInt(styles.solBreakpoint2Xl, 10);

  const greaterThanBreakpoint = useMediaQuery({
    query: `(min-width: ${breakpointLg}px)`,
  });

  const [nextEl, nextElRef] = useSwiperRef();
  const [prevEl, prevElRef] = useSwiperRef();

  return (
    <div className={styles.component}>
      <Container paddingY={false}>
        <div className={styles.grid}>
          <div className={styles.intro}>
            <Title size="lg">{title}</Title>
            <Text size="md">{description}</Text>
          </div>
          <div className={styles.controls}>
            <div className={styles.navigation}>
              <button type="button" ref={prevElRef} className={styles.previous}>
                <IconPrevious />
              </button>
              <button type="button" ref={nextElRef} className={styles.next}>
                <IconNext />
              </button>
            </div>
          </div>
        </div>
      </Container>
      <div className={styles.slides}>
        <div className={styles.overrides}>
          <Swiper
            modules={[Navigation]}
            breakpoints={{
              0: {
                slidesPerView: 1.25,
              },
              [breakpointLg]: {
                slidesPerView: 2.5,
                slidesPerGroup: 1,
              },
              [breakpoint2Xl]: {
                slidesPerView: 3.5,
                slidesPerGroup: 1,
              },
            }}
            slidesOffsetBefore={greaterThanBreakpoint ? 50 : 20}
            slidesOffsetAfter={greaterThanBreakpoint ? 50 : 20}
            cssMode={true && !greaterThanBreakpoint}
            watchOverflow
            simulateTouch={false}
            navigation={{
              prevEl,
              nextEl,
              lockClass: styles.lock,
              disabledClass: styles.disabled,
            }}
          >
            {highlights.map((e, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <SwiperSlide className={styles.slide} key={`experience-${idx}`}>
                <Highlight
                  photo={e.image}
                  name={e.title}
                  description={e.description}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

Highlights.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  highlights: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string,
        content_type: PropTypes.string,
        byte_size: PropTypes.number,
      }),
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
};
